export default "__VITE_ASSET__1599ae2b__"